import { render, staticRenderFns } from "./EmployeeInfo.vue?vue&type=template&id=327734a3&scoped=true&"
import script from "./EmployeeInfo.vue?vue&type=script&lang=ts&"
export * from "./EmployeeInfo.vue?vue&type=script&lang=ts&"
import style0 from "./EmployeeInfo.vue?vue&type=style&index=0&id=327734a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327734a3",
  null
  
)

export default component.exports